<template>

    <div class="flex flex-col w-full bg-white h-full">
        
        <div class="myenter">

            <ring-loader v-if="loading"/>
        </div>
        
        <div v-if="brandInfo != null">

          <div class="classPageRow">

              <label class="mr-5"><strong>{{$t('brand.instructorPicture')}} </strong></label>

              <img v-if="brandInfo.logo != ''" :src="brandInfo.logo" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
              <img v-else src="@/assets/images/full-logo.jpg" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
          </div>


          <div class="classPageRow">
                      
              <label class="mr-5"><strong>{{$t('business.brandName')}} </strong></label>

              <label
              class="classPageDetailsLabel">
              {{brandInfo.name}}</label>
          </div>
        
          <div class="classPageRow">

            <label class="mr-5"><strong>{{$t('business.categories')}} </strong></label>

            <label class="classPageDetailsLabel"><strong v-for="(item,i) in brandInfo.brand_to_brand_categories" :key="i"> ({{i + 1}}) {{item.brand_category.name}} <br> </strong></label>

          </div>

          <div class="classPageRow">
                      
            <label class="mr-5"><strong>{{$t('profile.phone')}}  </strong></label>

            <label
            class="classPageDetailsLabel">
              

                <a v-if="brandInfo.phone != 0" :href="`tel:${brandInfo.phone}`">
                  {{brandInfo.phone}}
                </a>
                <a v-else>
                  {{brandInfo.phone}}
                </a>
            </label>
          </div>
      
            <div class="classPageRow">
                        
                <label class="mr-5"><strong>{{$t('classes.description')}}  </strong></label>

                <p
                class="classPageDetailsLabel">
                {{brandInfo.description}}</p>
          </div>
        </div>

        <div v-else class="ml-1 mr-1 mb-1 lg:ml-20 lg:mr-20 lg:mb-20 items-center rounded-full">

            <label v-if="!loading"><strong>{{$t('brand.noInstructorIsAvailable')}}</strong></label>
        </div>

        <!-- <div v-if="brandInfo != null &&  brandInfo.id != 23">

            <sessions :myInstructorId="brandInfo.id" isFromInstructorBrowse="true"/>
        </div> -->

        <div class="myFixedPaddingHeight">

        </div>
    </div>
</template>

<script>

import myQueries from '../../hasura/myQueries';

import componentsHelpers from '../../classes/componentHelpers';
import sessions from '../../views-v2/Sessions'

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'

export default {

  props: {

    instructorId: 0,

    showInfoMethod: {

        type: Function
    }
  },
  
  components: {

    sessions
  },

  async mounted(){
    
    await this.loadData();
      // console.log(`instructorId: ${this.instructorId}`);
    this.fetchParameters();
  },

  methods: {

    async loadData(){

        try{

            const instructorId = this.instructorId;

            this.loading = true;

            let result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getInstructorWithId',
                data: {
                
                    instructorId: instructorId,
                }
            });

            // console.log(`result.data: ${JSON.stringify(result.data)}`);
            this.brandInfo = result.data.brand[0];

            this.loading = false;

        }catch(error){

            this.loading = false;

            componentsHelpers.sendError(this.$apollo, this.userId,'PublicInfo', 'InstrcutorPage', 'loadData', error);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            
            this.brandError = JSON.stringify(error);
        }
    },

     fetchParameters(){

        const parameters = this.$route.query;

        let instructorId = 0;

          // console.log(`${JSON.stringify(Number(parameters.selected))}`);
        
        if(typeof parameters.instructorId != 'undefined')
        {
            instructorId = Number(parameters.instructorId);
        }else if(this.instructorId != 0){

          instructorId = this.instructorId;
        }

        this.myInstructorId = instructorId;
      },

  },

  computed: {


  },


  data: function() {

    return {


      loading: false,

      brandName: '',

      brandInfo: null,

      myInstructorId: 0,

      userInfoError: '',

      brandError: '',

    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>